import { Box, Divider } from "@material-ui/core";
import styles from "./InsiderBenefits.module.css";
import insiderIllustration from "../../assets/illustration-insider.svg";
import checkIcon from "../../assets/icn-green-chck.svg";

const benefits = [
  "Unlimited Personal Support",
  "App Performance Optimizations",
  "Deceptive App Protection",
  "Malware Domain Protection",
  "Device Update Monitoring",
  "30 Days of Insider Access*",
];

const InsiderBenefits: React.FC = () => {
  return (
    <Box
      data-qatag="insiderBenefitsContainer"
      className={styles.insiderBenefitsContainer}
    >
      <Box
        data-qatag="insiderBenefitsContent"
        className={styles.insiderBenefitsContent}
      >
        <Box data-qatag="insiderBenefitsElements" className={styles.insiderBenefitsElements}>
          <img
            data-qatag="icon"
            className={styles.insiderIllustration}
            src={insiderIllustration}
            alt="insider-benefits"
          />
          <Box data-qatag="titleInsiderBenefits" className={styles.titleInsiderBenefits}>
            What You Get as a Solve iQ Insider For Your Entire Business
          </Box>
          <Box data-qatag="benefitText" className={styles.benefitText}>
            {benefits?.map((benefit) => (
              <Box
                key={benefit}
                data-qatag="benefit"
                display="flex"
                alignItems="center"
                mt={3}
              >
                <img
                  data-qatag="iconCheck"
                  className={styles.checkIcon}
                  src={checkIcon}
                  alt="insider-benefits"
                />
                {benefit}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      {/* Divider */}
      <Box data-qatag="divider" className={styles.divider}>
        <Divider data-qatag="dividerItem" />
      </Box>
    </Box>
  );
};

export default InsiderBenefits;
